import React from "react"
import { debounceStorage } from "..";
import { ui, state, temp } from "../interfaces/interfaces"
import { useAppSelector } from "../store/hooks";
import { GetApiCCMCostsGetAvailableOffersParams } from "@utils/apis/ccm/model";
import { apiCCM } from "@services/CCMAccess/apiAccess";

const getAvailableOffers = async () => {
    const body: GetApiCCMCostsGetAvailableOffersParams = {
        applicationId: 100,
        serviceAgreementId: 0,
        serviceAgreementTypeId: ui.CarePlanPlanDetailsPlanOptionsPlanType!.serviceAgreementTypeId,
        contractPeriod: 1,
        serviceAgreementDurationId: ui.CarePlanPlanDetailsPlanOptionsDuration!.serviceAgreementDurationId,
        userId: state.UserId,
        includeSystemOffers: false,
        serviceAgreementCampaignCodeId: 0,
        serviceAgreementBillingFrequencyId: ui.CarePlanPlanDetailsPlanOptionsBillingFrequency!.serviceAgreementBillingFrequencyId! > 3 ? ui.CarePlanPlanDetailsPlanOptionsDuration!.serviceAgreementDurationId : ui.CarePlanPlanDetailsPlanOptionsBillingFrequency!.serviceAgreementBillingFrequencyId,
        serviceAgreementExcessId: ui.CarePlanPlanDetailsPlanOptionsExcess!.serviceAgreementExcessId,
        website: false,
    }
    const offers = await apiCCM.getApiCCMCostsGetAvailableOffers(body);

    // Dirty exclusion of 18-Month Care Plan for the Price of 12 TODO: Remove this when API is fixed
    temp.AvailableOffers = offers.filter(o => !o.offerDescription?.startsWith("18-Month Care Plan for the Price of 12")).filter(o => !o.isFriendsAndFamilyOffer)
}

const useGetAvailableOffers = () => {
    // monitor for changes below VALUES
    const serviceAgreementPolicyPlanType = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsPlanType) //object
    const serviceAgreementBillingPaymentFrequencies = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsBillingFrequency) //object
    const serviceAgreementBillingDurations = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsDuration) //object
    const serviceAgreementBillingExcesses = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsExcess) //object

    // use memo to prevent unnecessary re-renders
    const dependencies = React.useMemo(() => ({
        planType: serviceAgreementPolicyPlanType,
        paymentFrequencies: serviceAgreementBillingPaymentFrequencies,
        durations: serviceAgreementBillingDurations,
        excesses: serviceAgreementBillingExcesses,
    }), [serviceAgreementPolicyPlanType, serviceAgreementBillingPaymentFrequencies, serviceAgreementBillingDurations, serviceAgreementBillingExcesses])

    // call effect if any of VALUES change
    React.useEffect(() => {
        // recalculate only if all values are set
        if (dependencies.planType?.serviceAgreementTypeId && dependencies.paymentFrequencies?.serviceAgreementBillingFrequencyId && dependencies.durations?.serviceAgreementDurationId && dependencies.excesses?.serviceAgreementExcessId !== undefined) {
            debounceStorage.addOrExecute({ name: "GetAvailableOffers", delay: 100, callback: getAvailableOffers })
        }
    }, [dependencies])
}

export default useGetAvailableOffers